import { HttpRequestAxios } from "../../axios"

export async function POST_LOGIN_USER(data: any) {


    return await HttpRequestAxios({ url: '/user/login', data: data })
}

export async function POST_LOGOUT() {

    return await HttpRequestAxios({ url: '/user/logout' })
}
export async function GET_PROFILE() {

    return await HttpRequestAxios({ url: '/user/profile' })
}

export async function POST_PROFILE_UPDATE(data: any) {
    return await HttpRequestAxios({ url: '/user/updateProfile', data: data })
}


